"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var CashPrices_1 = require("../../prices/cash/CashPrices");
var FinanceQuotePrices_1 = require("../../prices/finance/FinanceQuotePrices");
var carDetailsPricesWithFinanceStyles_1 = require("./carDetailsPricesWithFinanceStyles");
var clsx_1 = require("clsx");
var Translation_1 = require("../../../../../../common/components/presentation/Translation/Translation");
var CashPricesLabel_1 = require("../../prices/cash/label/CashPricesLabel");
var ReservationLabel_1 = require("../../prices/reservation/ReservationLabel");
var RepaymentAmount_1 = require("../../additionalCarDetails/repaymentAmount/RepaymentAmount");
var PaymentFrenquency_1 = require("../../additionalCarDetails/paymentFrequency/PaymentFrenquency");
var useSummaryContext_1 = require("../../../react/useSummaryContext");
var FinanceElementsTypes_1 = require("../../../../../../../../common/enum/FinanceElementsTypes");
var CarDetailsPricesWithFinance = function (_a) {
    var _b, _c, _d;
    var primary = _a.primary, secondary = _a.secondary, isMultiCurrency = _a.isMultiCurrency, financeDetails = _a.financeDetails, taxLabel = _a.taxLabel;
    var _e, _f;
    var style = carDetailsPricesWithFinanceStyles_1.default();
    var _g = core_1.useTheme().checkoutLite, showRepaymentAmount = _g.showRepaymentAmount, showPaymentFrequency = _g.showPaymentFrequency, enquiryForm = _g.enquiryForm, _h = _g.summary, hideReservationLabel = _h.hideReservationLabel, hideFrequencyLabel = _h.hideFrequencyLabel;
    var showCarPricesLabel = (enquiryForm || {}).showCarPricesLabel;
    var financeDisclaimerBreakdown = useSummaryContext_1.default().financeDisclaimerBreakdown;
    var disclaimer;
    if ((_e = financeDisclaimerBreakdown) === null || _e === void 0 ? void 0 : _e.schema)
        disclaimer = JSON.parse((_f = financeDisclaimerBreakdown) === null || _f === void 0 ? void 0 : _f.schema);
    var getDisclaimers = react_1.useCallback(function (purpose) {
        var _a, _b, _c, _d, _e, _f;
        var disclaimers = (_e = (_d = (_c = (_b = (_a = disclaimer) === null || _a === void 0 ? void 0 : _a.schema) === null || _b === void 0 ? void 0 : _b.properties) === null || _c === void 0 ? void 0 : _c.disclaimer) === null || _d === void 0 ? void 0 : _d.title) === null || _e === void 0 ? void 0 : _e.json;
        if (Array.isArray(disclaimers))
            return (_f = disclaimers.find(function (key) { return key.purpose === purpose; })) === null || _f === void 0 ? void 0 : _f.description;
    }, []);
    var handleFinanceQuotePrices = react_1.useCallback(function () {
        // it means no frequency translation comes from BE, fix to not block the flow
        var frequencyLabelAfter = financeDetails.frequency ? <Translation_1.default id={financeDetails.frequency}/> : '---';
        if (showPaymentFrequency) {
            return (<>
          <core_1.Divider orientation="vertical" variant="middle" flexItem hidden={!showPaymentFrequency} className={clsx_1.default(style.addDetailsDivider, style.hideDivider)}/>
          <PaymentFrenquency_1.default primaryPrice={financeDetails.primary} labelAfter={frequencyLabelAfter} dataTest={'price:finance_quote_primary'} disclaimer={getDisclaimers(FinanceElementsTypes_1.default.REPAYMENT)}/>
        </>);
        }
        return (<>
        <core_1.Divider orientation="vertical" data-test="summary:element:divider" className={style.divider}/>
        <FinanceQuotePrices_1.default primaryPrice={financeDetails.primary} secondaryPrice={financeDetails.secondary} isMultiCurrency={isMultiCurrency} dataTest="price:finance_quote_primary" labelBefore={<Translation_1.default id={'trans__checkout__vehicle_details__price_finance_from_label'}/>} labelAfter={!hideFrequencyLabel && frequencyLabelAfter} variant={'body1'} taxLabel={taxLabel}/>
      </>);
    }, [taxLabel]);
    var isAddedDetails = showRepaymentAmount && showPaymentFrequency;
    return (<>
      <core_1.Box display="flex" flexDirection="column" padding="5px" alignItems="center">
        <core_1.Box className={clsx_1.default(style.wrapper, (_b = {}, _b[style.multiWrapper] = isMultiCurrency, _b), (_c = {}, _c[style.addedDetailsLayout] = isAddedDetails, _c))}>
          <CashPrices_1.default primaryPrice={primary} dataTest="summary:text:car_price" secondaryPrice={secondary} isMultiCurrency={isMultiCurrency} hideLabel={!!showCarPricesLabel} taxLabel={taxLabel}/>
          <core_1.Box component="span" className={clsx_1.default(style.prices, (_d = {}, _d[style.multiWrapper] = isMultiCurrency, _d))}>
            {handleFinanceQuotePrices()}
            {showRepaymentAmount && (<>
                <core_1.Divider orientation="vertical" className={style.addDetailsDivider} variant="middle" flexItem hidden={!showRepaymentAmount}/>
                <RepaymentAmount_1.default percentageValue={financeDetails.comparisonRate} disclaimer={getDisclaimers(FinanceElementsTypes_1.default.CAP_COMPARISON_RATE)}/>
              </>)}
          </core_1.Box>
        </core_1.Box>
        {showCarPricesLabel && <CashPricesLabel_1.default />}
      </core_1.Box>
      {!hideReservationLabel && <ReservationLabel_1.default />}
    </>);
};
exports.default = CarDetailsPricesWithFinance;
